import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { IframeModalComponent } from './iframe-modal.component';
import { SanitizePipeModule } from '@digistore/ds24-ui/pipes';

@NgModule({
  declarations: [IframeModalComponent],
  imports: [CommonModule, DialogModule, SanitizePipeModule],
  exports: [IframeModalComponent],
})
export class IframeModalModule {}
